// extracted by mini-css-extract-plugin
module.exports = {"container":"uiPaper_container__3vo8J","root":"uiPaper_root__2RNrL"};
    if(module.hot) {
      // 1783592038220
      var cssReload = require("!../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  